import React, { Component } from 'react'

import style from './Grid.css'

export default class Clearfix extends Component {
  render() {
    return (
      <div
        {...this.props}
        className={`${style.clearfix} ${(this.props.float) ? style['float'+this.props.float] : ''} ${this.props.className || ''}`}
        style={{
          ...this.props.style
        }}
        >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Grid/Clearfix.js